export const STATIC_TAGS = {
  "twitter:site": "@Prothomalo",
  "twitter:app:name:ipad": undefined,
  "twitter:app:name:googleplay": undefined,
  "twitter:app:id:googleplay": undefined,
  "twitter:app:name:iphone": undefined,
  "twitter:app:id:iphone": undefined,
  "apple-itunes-app": undefined,
  "google-play-app": undefined,
  "fb:app_id": "1499138263726489",
  "fb:pages": "163059227060505",
  "og:site_name": "চিরন্তন ১৯৭১ | প্রথম আলো",
};

export const SOCIAL_TAG = {
  muktijuddho: {
    "fb:pages": "163059227060505",
    "og:site_name": "চিরন্তন ১৯৭১ | প্রথম আলো",
    "twitter:site": "@Prothomalo",
  },
};

export const MICROSITES = ["muktijuddho"];

export const MICROSITES_OLD_URLS = [["/muktijuddho-50", "https://1971.prothomalo.com"]];
